import { find, flatMap, isArray, isObject } from 'lodash';

export function deepGetFirstNumberOrString(value: any): string | number {
    if (typeof value === 'string' || typeof value === 'number') return value;

    const flattenedValues = flatMap(value);
    if (flattenedValues.length <= 0) return '';

    const firstValue = find(flattenedValues, it => !!it);
    if (typeof firstValue === 'string' || typeof firstValue === 'number') return firstValue;

    if (isArray(firstValue) || isObject(firstValue)) return deepGetFirstNumberOrString(firstValue);

    return '';
}
